import {cs}                from "@Common/react/chain-services";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {changeNestedValue} from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";
import {omit}              from "@Common/utils/objects";

export const NcoaFailedLogic = ({item, next: rootNext}) => cs(

    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            item?.selections?.ncoaFailed,

            (selected) => ({
                saved  : selected,
                current: selected,
            }),
        ),
        next,
    })],
    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["selections"], (_) => omit(_, ["ncoaFailed"])),
        next,
    })],

    ({state, step1}) => step1.next(!step1.failedCount ? null : {
        itemEditor: {
            $name: "NCOA failed",
            changed: state.value.saved !== state.value.current,

            prepareSave: (item) => ({
                newValue: changeNestedValue(item, ["selections", "ncoaFailed"], (_) => !!state.value.current),
                onSaved: () => setCurrentToSaved(state),
            }),

            valid: true,
        },
        selected: state.value.current,
        ui: {
            state: scopedState(state, ["current"]),
            count: step1.failedCount,
        },
    }),
);

